import {
  type GraphInputMode,
  type ItemClickedEventArgs,
  type IModelItem,
  INode,
  GraphComponent,
  ModifierKeys,
  ILabel,
  IEdge,
} from '@ardoq/yfiles';
import { dispatchAction } from '@ardoq/rxbeach';
import { ViewIds } from '@ardoq/api-types';
import { isMac } from '@ardoq/common-helpers';
import { graphItemRightClickedListener } from './graphItemRightClickedListener';
import { graphItemClicked } from './actions';

const modelItemOwner = (item: IModelItem): INode | IEdge | null => {
  if (item instanceof INode || item instanceof IEdge) {
    return item;
  }
  if (item instanceof ILabel) {
    return item.owner as INode | IEdge;
  }
  return null;
};

const graphItemClickedListenerModernized =
  (viewId: ViewIds | null, viewInstanceId: string) =>
  (e: ItemClickedEventArgs<IModelItem>, inputMode: GraphInputMode): void => {
    if (isMac() && e.modifiers === ModifierKeys.CONTROL) {
      graphItemRightClickedListener({
        graphComponent: e.context.canvasComponent as GraphComponent,
        isViewpointMode: () => true,
        viewId: viewId || ViewIds.MODERNIZED_BLOCK_DIAGRAM,
        viewInstanceId,
      })(e, inputMode);
      return;
    }

    dispatchAction(graphItemClicked({ event: e, viewId, viewInstanceId }));
  };

export { graphItemClickedListenerModernized, modelItemOwner };
